import {
  Grid,
  TextLabel,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoginUserStore } from '../../../../../models/useLoginUserModel';
import { validateEmail } from '../../../../../utils/common';
import SelectTag from '../../../SelectTag';
import style from '../../index.module.less';
import { useOneTimeReportStore } from '../../store';

interface Account {
  account: string;
  email: string;
}

const Recipients = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const { user } = useLoginUserStore();
  const [accountOpts, setAccountOpts] = useState<Account[]>([]);

  //getter
  const recipients = useOneTimeReportStore(
    (store) => store.notification.recipients
  );
  const recipientError = useOneTimeReportStore(
    (store) => store.error.recipientError
  );
  //setter
  const setRecipients = useOneTimeReportStore((store) => store.setRecipients);

  const setRecipientError = useOneTimeReportStore(
    (store) => store.setRecipientError
  );

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const tagErrors = document
      .querySelector('#recipient-select')
      ?.querySelectorAll('.select-tag-error');
    if (
      (tagErrors && tagErrors.length > 0) ||
      recipients.join('').length > 255
    ) {
      setRecipientError(true);
    } else {
      setRecipientError(false);
    }
  }, [recipients]);

  useEffect(() => {
    const clpEmail = user?.accountEmail;
    if (clpEmail) {
      setAccountOpts([
        {
          account: clpEmail,
          email: clpEmail,
        },
      ]);
      setRecipients([clpEmail]);
    }
  }, [user]);

  useEffect(() => {
    const cb = () => {
      setRecipients([]);
      setRecipientError(false);
    };

    register(cb);
    return () => unregister(cb);
  }, []);

  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.recipients')}:
      </TextLabel>
      <Grid id="recipient-select">
        <SelectTag
          width="400px"
          options={accountOpts}
          fieldNames={{
            label: 'account',
            value: 'email',
          }}
          onChange={(v: any) => setRecipients(v)}
          rule={validateEmail}
          selections={recipients}
          inputError={recipientError}
        />
        {recipientError && (
          <Text
            fontSize="sm"
            lineHeight="sm"
            color={colorStyle.color.error}
            textAlign="left"
          >
            {recipients.join('').length > 255
              ? t('reportCommon.tips.errors.emailLength')
              : t('reportCommon.tips.errors.emailFormat')}
          </Text>
        )}
        <Text mt="4px" color={colorStyle.color.secondary}>
          {t('reportCommon.tips.hints.recipientsInput')}
        </Text>
      </Grid>
    </>
  );
};

export default Recipients;
